import { StructuredSurvey } from '@dreryk/egabinet-survey-frontend-api';

// TODO DREGAB-29796: read the real per-section showOnVisit flag from StructuredSurvey once the backend exposes it
export const readInitialShowOnVisit = (
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   structuredSurvey: StructuredSurvey | null,
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   sectionId: number
): boolean => false;

// TODO DREGAB-29796: decide how showOnVisit is carried on SectionAnswersSaveCommand once the backend exposes the field
export const applyShowOnVisitToPayload = <T extends { readonly showOnVisit?: boolean }>(
   payload: T,
   showOnVisit: boolean
): T => ({ ...payload, showOnVisit: showOnVisit });
